// extracted by css-extract-rspack-plugin
module.exports =  {"tabs":"Tabs-CjRa__tabs"};